import {
  AgreementType,
  ApplicationProductTypeEnum,
} from '@varo/graphql-schema-types';
import useExternalAccountsForTransferSource from 'features/advance/hooks/useExternalAccountsForTransferSource';
import useAgreements from 'shared/hooks/useAgreements/useAgreements';

const useInitialQueries = () => {
  const {
    response: externalAccountsResponse,
    loading: externalAccountsLoading,
    errorModel: externalAccountsError,
    refresh: refreshExternalAccounts,
  } = useExternalAccountsForTransferSource();

  const {
    agreementsListDetails: agreementsData,
    errorModel: agreementsError,
    loading: agreementsFetching,
  } = useAgreements([ApplicationProductTypeEnum.AdvancePlaidLinking]);

  const plaidAgreementId = agreementsData?.find(
    (agreement) =>
      agreement.type === AgreementType.AdvanceV2PlaidLinkingAgreement,
  )?.id;

  return {
    isFetching: externalAccountsLoading || agreementsFetching,
    hasExternalAccounts: externalAccountsResponse?.length > 0,
    plaidAgreementId,
    hasError: !!agreementsError || externalAccountsError?.messageBody,
    refreshExternalAccounts,
  };
};

export default useInitialQueries;
